/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=467009f5&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"
import style0 from "./Playground.vue?vue&type=style&index=0&id=467009f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467009f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467009f5')) {
      api.createRecord('467009f5', component.options)
    } else {
      api.reload('467009f5', component.options)
    }
    module.hot.accept("./Playground.vue?vue&type=template&id=467009f5&scoped=true", function () {
      api.rerender('467009f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Playground.vue"
export default component.exports